import { Typography, Card, CardContent, Box, Button } from "@mui/material";
import { useLocation, Navigate } from 'react-router-dom'
import { getOrderById, confyrmOrder } from '../http/orderAPI'
import { useEffect, useState } from 'react'


const PageConfyrm = () => {

    const location = useLocation();
    const pathArray = location.pathname.split('/')
    const orderId = pathArray[pathArray.length - 1]

    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(true)
    const [invalidOrder, setInvalidOrder] = useState(false)
    const [showDone, setShowDome] = useState(false)
    const handlerConfyrm = (id) => {

        const fetchOrderConfyrm = async (id) => {
            try {
                const data = await confyrmOrder(id)
                setShowDome(true)
            } catch (e) {
                console.error(e)
                setInvalidOrder(true)
            } finally {
                setLoading(false)
            }
        }

        fetchOrderConfyrm(id);


    }

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const data = await getOrderById(orderId)

                // 🔴 проверка ответа
                if (!data || data.orderId === null || data.status === 'обработка') {
                    setInvalidOrder(true)
                    return
                }

                setOrder(data)
            } catch (e) {
                console.error(e)
                setInvalidOrder(true)
            } finally {
                setLoading(false)
            }
        }

        if (orderId) {
            fetchOrder()
        }
    }, [orderId])

    if (!orderId || invalidOrder) {
        return <Navigate to="/" />;
    }

    if (loading) {
        return <Typography align="center">Загрузка...</Typography>
    }



    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="40vh"
                >
                    {
                        showDone ?
                            <>
                                <Box display='flex' justifyContent='center' alignItems='center'>
                                    <svg width="100px" height="100px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#00f1ff" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z" /></svg>
                                </Box>
                                <Typography align='center' variant="h4" sx={{ mb: 2, mt: 2 }}>
                                    Вы подтвердили сделку <br />по вашему заказу # {orderId}
                                </Typography>
                                <Typography align='center'>Благодарим, что выбрали наш сервис!</Typography>
                            </>

                            :
                            <>
                                <Typography align='center' variant="h4" sx={{ mb: 2, mt: 2 }}>
                                    Подтвердить сделку <br />по вашему заказу # {orderId}
                                </Typography>
                                <Box display='flex' justifyContent='center' alignItems='center'>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size={"medium"}
                                        onClick={() => handlerConfyrm(orderId)}
                                    >Подтвердить</Button>
                                </Box>
                            </>
                    }


                </Box>
            </CardContent>
        </Card>
    )
}

export default PageConfyrm;